import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";
import { useT } from "../lib/i18n";

export default function AdminLogin() {
  const { t } = useT();
  const navigate = useNavigate();
  const [email, setEmail] = React.useState("admin@blueworld.ae");
  const [password, setPassword] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/auth/login", { email, password });
      localStorage.setItem("bw_admin_token", res.data.token);
      toast.success(t("toast.logged_in"));
      navigate("/admin");
    } catch {
      toast.error(t("toast.invalid_creds"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-zinc-950 text-white flex items-center justify-center relative overflow-hidden">
      <div className="absolute inset-0 bp-grid-dark opacity-50"></div>
      <div className="relative max-w-md w-full mx-4">
        <Link to="/" className="font-mono-tech text-[10px] uppercase text-zinc-500 hover:text-white mb-6 inline-block">{t("admin_login.back")}</Link>
        <div className="bg-white text-zinc-900 border border-zinc-900" style={{ boxShadow: "10px 10px 0 0 #031833" }}>
          <div className="p-8">
            <div className="font-mono-tech text-[10px] uppercase text-[#031833] mb-2">{t("admin_login.kicker")}</div>
            <h1 className="font-display text-3xl tracking-tighter mb-6">{t("admin_login.title_a")}<br />{t("admin_login.title_b")}</h1>
            <form onSubmit={submit} className="space-y-3">
              <div>
                <label className="font-mono-tech text-[10px] uppercase text-zinc-500 block mb-1">{t("admin_login.email")}</label>
                <input data-testid="login-email" required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full border border-zinc-300 px-3 py-3 font-mono-tech text-sm outline-none focus:border-[#031833]" />
              </div>
              <div>
                <label className="font-mono-tech text-[10px] uppercase text-zinc-500 block mb-1">{t("admin_login.password")}</label>
                <input data-testid="login-password" required type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full border border-zinc-300 px-3 py-3 font-mono-tech text-sm outline-none focus:border-[#031833]" />
              </div>
              <button data-testid="login-submit" disabled={loading} className="w-full bg-zinc-950 text-white font-mono-tech text-sm uppercase py-3 hover:bg-[#031833] disabled:opacity-50">
                {loading ? t("admin_login.submitting") : t("admin_login.submit")}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
